import { Component, EventEmitter, Injectable, Input, Output, ViewChild } from '@angular/core';
import { DataServiceService } from '../../services/data-service.service';
import { Customers, dispatchOrders, DriverCard, Orders } from '../../interfaces';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { switchMap } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { MessageService } from 'primeng/api';
import { SendDispatchComponent } from '../../dispatch/send-dispatch/send-dispatch.component';
import { formatDispatchOrdersForCard, type TruckContact } from '../../dispatch/send-dispatch/send-dispatch.helpers';


@Injectable()
export class PopupConfirmationService extends ConfirmationService { }

@Injectable()
export class DialogConfirmationService extends ConfirmationService { }

@Component({
  selector: 'app-speed-dial-items',
  templateUrl: './speed-dial-items.component.html',
  styleUrl: './speed-dial-items.component.scss'
})
export class SpeedDialItemsComponent {

  @ViewChild('dispatchDialog') dispatchDialog!: SendDispatchComponent;

  @Input() allOrders: Orders[] = []
  @Input() card!: DriverCard;
  @Input() orderInfo!: dispatchOrders;
  @Input() driverCards: DriverCard[] = [];
  /** Pre-resolved truck inbox + label for this row’s driver (from dashboard). */
  @Input() truckContact: TruckContact = { truckEmail: '', truckNumber: 'No Truck Assigned' };
  /** Same calendar day as the dashboard dispatch view (for email header + formatting). */
  @Input() selectedDate: Date | null = null;
  @Output() notesSaved = new EventEmitter<{
    driverId: number,
    orderId: number,
    notes: string
  }>();

  trailers: any[] = [];
  customers: Customers[] = [];

  showNotesDialog = false;
  currentNotes: string = '';
  speedDialitems: MenuItem[] | null = [];
  selectedDriverDispatch: number = -1;
  selectedOrderId: number = -1;
  showFormDialog: boolean = false;
  currentTrailerNumber: any;

  driverOptions: any = [];

  // Component properties
  currentLoad: any = null;
  selectedDriver: any = null;
  selectedRole: 'pickup' | 'dropoff' | null = null;
  showSplitDialog = false;
  dt1: any; // Add this line to define the dt1 property
  hasAccess = false;
  showSendDispatchDialog: boolean = false;


  constructor(private dataServiceService: DataServiceService, private router: Router,
    private confirmationService: ConfirmationService, private route:ActivatedRoute,
    private authService: AuthService, private messageService: MessageService
  ) { }

  ngOnInit() {

    this.dataServiceService.orders$.subscribe(orders => {
      this.allOrders = orders;
    });
    this.dataServiceService.trailers$.subscribe(trailers => {
      this.trailers = trailers;
    });

    this.dataServiceService.customers$.subscribe(customers => {
      this.customers = customers;
    });

    this.authService.userProfile$.subscribe((profile) => {
      if (profile?.roles?.includes('Dispatcher') || profile?.roles?.includes('Admin')) {
        this.hasAccess = true;
      } else {
        this.hasAccess = false;
      }
    });

    this.speedDialitems = [
      {
      icon: 'pi pi-trash',
      tooltipOptions: {
        tooltipLabel: 'Remove From Driver',
        tooltipPosition: 'right'
      },
      command: () => {
        if (this.selectedDriverDispatch && this.selectedOrderId) {
        this.confirmRemoval()
        }
      }
      },
      {
      icon: 'pi pi-upload',
      tooltipOptions: {
        tooltipLabel: 'Generate Form',
        tooltipPosition: 'left'
      },
      command: () => {
        this.showFormDialog = true
      }
      },
      {
      icon: 'pi pi-external-link',
      tooltipOptions: {
        tooltipLabel: 'Split Load',
        tooltipPosition: 'left'
      },
      command: () => {
        if (this.selectedDriverDispatch && this.selectedOrderId) {
        this.splitLoadDialog(this.selectedDriverDispatch, this.selectedOrderId)
        }
      }
      },
      {
      icon: 'pi pi-file-edit',
      tooltipOptions: {
        tooltipLabel: 'Add/Edit Notes',
        tooltipPosition: 'left'
      },
      command: () => {
        this.openNotesDialog(this.selectedDriverDispatch, this.selectedOrderId);
      }
      },
      {
      icon: 'pi pi-send',
      tooltipOptions: {
        tooltipLabel: 'Send Dispatch',
        tooltipPosition: 'left'
      },
      command: () => {
        this.openDispatchDialog(this.card);
      }
      },
      {
      icon: 'pi pi-info-circle',
      tooltipOptions: {
        tooltipLabel: 'More Info',
        tooltipPosition: 'right'
      },
      command: () => {
        // Since orders are now sorted in descending order, we need to adjust the index calculation
        const orderIndex = this.allOrders
            .sort((a, b) => b.order_id - a.order_id) // Sort in same order as display
            .findIndex(order => order.order_id === this.selectedOrderId);
        const pageIndex = Math.floor(orderIndex / 10);
        
        this.router.navigate(['/orders'], { 
            queryParams: { 
                orderId: this.selectedOrderId, 
                pageIndex: pageIndex,
                openOrder: true,
                expand: true
            }
        });
      }}
    ]
  }

  ////////Fix this//////////
  sendDispatchDialog(selectedDriverDispatch: number, selectedOrderId: number) {
    this.selectedDriverDispatch = selectedDriverDispatch;
    this.selectedOrderId = selectedOrderId;
    this.showSendDispatchDialog = true;
  }


  getDriverSpeedDial(driverId: number, loadId: number) {
    this.selectedDriverDispatch = driverId;
    this.selectedOrderId = loadId;


    const order = this.allOrders.find(o => o.order_id === this.selectedOrderId);
    if (order) {
      // Find the trailer using the trailerId from the order
      const trailer = this.trailers.find(t => t.trailer_id === order.trailer_id);
      if (trailer) {
        this.currentTrailerNumber = trailer.trailer_number; // or whatever property holds the trailer number
      }
    }
  }

  openNotesDialog(driverId: number, orderId: number) {
    this.selectedDriverDispatch = driverId;
    this.selectedOrderId = orderId;
    this.showNotesDialog = true;

    // Find the order in the allOrders array instead
    const order = this.allOrders.find(o => o.order_id === orderId);
    if (order) {
      this.currentNotes = order.notes || '';
    }
  }

  saveNotes() {
    const updatedData = {
      notes: this.currentNotes.trim()
    };

    this.dataServiceService.updateOrder(this.selectedOrderId, updatedData).subscribe({
      next: (response) => {
        this.currentNotes = '';
        this.showNotesDialog = false;
      },
      error: (error) => {
        console.error('Failed to update notes:', error);
      }
    });
  }

  confirmRemoval() {
    const dailyDispatchId = this.getDailyDispatchId(this.selectedDriverDispatch);

    if (!dailyDispatchId) {
      console.error('No daily dispatch ID found');
      return;
    }

    this.confirmationService.confirm({
      message: 'Do you want to remove this order from the driver?',
      icon: 'pi pi-info-circle',
      acceptLabel: 'Yes',
      rejectLabel: 'No',
      acceptButtonStyleClass: "p-button-success p-button-outlined p-button-sm",
      rejectButtonStyleClass: "p-button-danger p-button-outlined p-button-sm",
      accept: () => {
        if (this.selectedDriverDispatch !== -1 && this.selectedOrderId !== -1) {
          this.removeFromDriver(this.selectedDriverDispatch, this.selectedOrderId);
        }
      }
    });
  }

  private getDailyDispatchId(driverId: number): number | null {
    const driver = this.driverCards.find(d => d.driver.driver_id === driverId);
    return driver?.dailyDispatch.id || null;
  }

  removeFromDriver(driverId: number, orderId: number) {
    const order = this.allOrders.find(o => o.order_id === orderId);
    
    if (!order) {
      console.error('Order not found:', orderId);
      return;
    }
  
    const dailyDispatchId = this.getDailyDispatchId(driverId);
    if (!dailyDispatchId) {
      console.error('Daily dispatch ID not found for driver:', driverId);
      return;
    }
  
    // Check if it's a split load
    if (order.pickup_driver_id !== order.delivery_driver_id) {
      // Determine which driver is being removed and who's the remaining driver
      const isRemovingPickup = order.pickup_driver_id === driverId;
      const remainingDriverId = isRemovingPickup ? order.delivery_driver_id : order.pickup_driver_id;
  
      // Update the order to consolidate under the remaining driver
      const updatedOrder = {
        ...order,
        pickup_driver_id: remainingDriverId,
        delivery_driver_id: remainingDriverId
      };
  
      // First update the order to consolidate under remaining driver
      this.dataServiceService.updateOrder(orderId, updatedOrder).subscribe({
        next: () => {
          // Only remove from the current driver's dispatch
          this.dataServiceService.removeOrderFromDriverDispatch(
            driverId, 
            dailyDispatchId, 
            orderId, 
          ).subscribe({
            next: () => {
              console.log('Split load consolidated and removed from driver:', driverId);
     
            },
            error: (error) => {
              console.error('Failed to remove from dispatch:', error);
            }
          });
        },
        error: (error) => {
          console.error('Failed to consolidate split load:', error);
        }
      });
    } else {
      // Regular removal for non-split loads
      this.dataServiceService.removeOrderFromDriverDispatch(
        driverId, 
        dailyDispatchId, 
        orderId, 
        'Unassigned'
      ).subscribe({
        next: (response) => {
          console.log('Order removed successfully:', response);
 
        },
        error: (error) => {
          console.error('Failed to remove order:', error);
        }
      });
    }
  }

prepareTrailerNumber(formType: string) {
  const order = this.allOrders.find(o => o.order_id === this.selectedOrderId);

  if (order) {
    if (order.trailer_id) {
      const trailer = this.trailers.find((t: { trailer_id: number; }) => t.trailer_id === order.trailer_id);
      if (trailer) {
        this.currentTrailerNumber = trailer.trailer_number;
      }
    } else if (order.external_trailer_number) {
      this.currentTrailerNumber = order.external_trailer_number;
    }
  }

  if (!this.currentTrailerNumber) {
    console.error('No trailer number found');
    return;
  }

if (formType === 'plastic') {
  this.generateForm(this.currentTrailerNumber);
} else if (formType === 'other') {
  this.handleOtherWashout(this.currentTrailerNumber);
}
}


/// Generate and download PDF file
generateForm(trailerNumber: string) {
  
  this.dataServiceService.generateForm(trailerNumber, 'plastic').subscribe({
    next: (response: any) => {
      // Check if response is actually a Blob with PDF content
      if (response instanceof Blob && response.type === 'application/pdf') {
        // Create a URL for the blob
        const url = window.URL.createObjectURL(response);
        
        // Create and trigger download
        const link = document.createElement('a');
        const currentDate = new Date().toLocaleDateString().replace(/\//g, '-');
        link.href = url;
        link.download = `plastic-washout-form-${this.currentTrailerNumber}-${currentDate}.pdf`;
        
        // Trigger download and cleanup
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.showFormDialog = false;
      } else {
        // Handle case where response is not a PDF blob
        console.error('Unexpected response format:', response);
        if (response instanceof Blob) {
          // Try to read the blob as text to see what it contains
          const reader = new FileReader();
          reader.onload = () => {
            console.error('Response content:', reader.result);
          };
          reader.readAsText(response);
        }
      }
    },
    error: (error) => {
      console.error('Failed to generate washout form:', error);
      
      // Try to extract more information from the error
      if (error.error instanceof Blob) {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const errorJson = JSON.parse(reader.result as string);
            console.error('Error details:', errorJson);
          } catch (e) {
            console.error('Error content (not JSON):', reader.result);
          }
        };
        reader.readAsText(error.error);
      }
    }
  });
}

handleOtherWashout(trailerNumber: string) {
  
  this.dataServiceService.generateForm(trailerNumber, 'other').subscribe({
    next: (response: any) => {
      // Check if response is actually a Blob with PDF content
      if (response instanceof Blob && response.type === 'application/pdf') {
        // Create a URL for the blob
        const url = window.URL.createObjectURL(response);
        
        // Create and trigger download
        const link = document.createElement('a');
        const currentDate = new Date().toLocaleDateString().replace(/\//g, '-');
        link.href = url;
        link.download = `washout-form-${this.currentTrailerNumber}-${currentDate}.pdf`;
        
        // Trigger download and cleanup
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.showFormDialog = false;
      } else {
        // Handle case where response is not a PDF blob
        console.error('Unexpected response format:', response);
        if (response instanceof Blob) {
          // Try to read the blob as text to see what it contains
          const reader = new FileReader();
          reader.onload = () => {
            console.error('Response content:', reader.result);
          };
          reader.readAsText(response);
        }
      }
    },
    error: (error) => {
      console.error('Failed to generate washout form:', error);
      
      // Try to extract more information from the error
      if (error.error instanceof Blob) {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const errorJson = JSON.parse(reader.result as string);
            console.error('Error details:', errorJson);
          } catch (e) {
            console.error('Error content (not JSON):', reader.result);
          }
        };
        reader.readAsText(error.error);
      }
    }
  });
}


  splitLoadDialog(driverId: number, loadId: number) {
    this.driverOptions = this.driverCards.filter(d => d.driver.driver_id !== this.selectedDriverDispatch)
    this.selectedDriverDispatch = driverId;
    this.selectedOrderId = loadId;
    this.showSplitDialog = true;
    let driver = this.driverCards.find(d => d.driver.driver_id === driverId);
    if (driver) {
      let load = driver.dispatchOrders.find(l => l.id === loadId);
      if (load) {
        this.currentLoad = load; // Store current load for reference
      }
    }
  }

  // Selecting driver for splitting loads
  onDriverSelect(event: any) {
    this.selectedDriver = event.value
  }

  // Selecting the role for splitting loads
  onRoleSelect(event: any) {
    this.selectedRole = event.value;
  }


  saveRole() {    
    // Find original and secondary drivers
    let driver = this.driverCards.find(d => d.driver.driver_id === this.selectedDriverDispatch);
    let secondaryDriver = this.driverCards.find(d => d.driver.driver_id === this.selectedDriver.driver.driver_id);
   
    if (driver && secondaryDriver) {
      let load = this.allOrders.find(l => l.order_id === this.selectedOrderId);
      
      if (load) {
        // Create updated order data
        const updatedOrder = {
          pickup_driver_id: this.selectedRole === 'pickup' ? 
            this.selectedDriver.driver.driver_id : 
            this.selectedDriverDispatch,
          delivery_driver_id: this.selectedRole === 'dropoff' ? 
            this.selectedDriver.driver.driver_id : 
            this.selectedDriverDispatch
        };
   
        // Create dispatch order data for secondary driver
        const dispatchOrderData = {
          order_id: load.order_id,
          priority: String(secondaryDriver.dispatchOrders?.length + 1 || 1),
          scheduled_time: new Date().toISOString(),
          notes: load.notes || '',
          load_status: load.load_status
        };
   
        // Update order and create dispatch order in sequence
        this.dataServiceService.updateOrder(this.selectedOrderId, updatedOrder).pipe(
          switchMap(() => {
            // After order update, assign to secondary driver's dispatch
            return this.dataServiceService.assignSplitOrderToDispatch(
              secondaryDriver.driver.driver_id,
              secondaryDriver.dailyDispatch.id, 
              dispatchOrderData
            );
          })
        ).subscribe({
          next: () => {
            this.showSplitDialog = false;
            this.resetForm();
            this.dataServiceService.refreshDriverCards(); // Refresh UI
            // Add the toast message here - shows exactly once!
            this.messageService.add({
              severity: 'success',
              summary: 'Order Split',
              detail: `Order has been split and assigned to ${secondaryDriver.driver.first_name} ${secondaryDriver.driver.last_name}`,
              life: 3000
            });
          },
          error: (error) => {
            console.error('Error in split load operation:', error);
          }
        });
      }
    }
   }
   
   private resetForm() {
    this.selectedDriver = null;
    this.selectedRole = null;
    this.currentLoad = null;
   }
  
  
  openDispatchDialog(card: DriverCard) {
    const dispatchText = formatDispatchOrdersForCard(
      card,
      this.selectedDate,
      this.allOrders,
      this.customers,
      this.trailers
    );
    this.dispatchDialog.showEmailDialog(dispatchText, this.truckContact);
  }

  }